export const createAdminPaymentIdempotencyKey = () => {
    const uuid = typeof window !== 'undefined' ? window.crypto?.randomUUID?.() : null;
    const randomPart = uuid || `${Date.now()}-${Math.random().toString(36).slice(2, 14)}`;
    return `admin-payment-${randomPart}`.slice(0, 64);
};

export const resolveAdminPaymentAttempt = (previous, kind, payload) => {
    const fingerprint = `${kind}:${JSON.stringify(payload)}`;
    if (previous?.fingerprint === fingerprint && previous?.key) return previous;
    return { fingerprint, key: createAdminPaymentIdempotencyKey() };
};

const positivePair = (value) => Array.isArray(value) && Number.isSafeInteger(value[0]) && value[0] > 0 && Number(value[1]) === 1;

export const isSitePaymentResponse = (response) =>
    response?.data?.ok === true &&
    positivePair(response?.data?.data?.user_pay_info) &&
    positivePair(response?.data?.data?.gathering_pay);

export const isKensingtonPaymentResponse = (response) => response?.data?.ok === true && positivePair(response?.data?.data);
